import { filterAndSortFormData } from "../DynamicForm/utils";

export const processAndFormatSubSections = (
  sectionLayout: any,
  selectedOption: string,
  priceMode: number
) => {
  if (!sectionLayout?.["sub-sections"]) return [];

  const subSectionsObj = Object.values?.(sectionLayout?.["sub-sections"]);
  const formattedInputs = subSectionsObj?.reduce((acc: any, section: any) => {
    const option = section?.name?.includes("_")
      ? section.name.split("_")[1]
      : section?.name;
    acc[option] = section.custom_input;
    return acc;
  }, {});

  return filterAndSortFormData(
    formattedInputs?.[selectedOption as keyof typeof formattedInputs],
    priceMode
  );
};
